import { render, staticRenderFns } from "./admin-estates-list.vue?vue&type=template&id=0ac13142&scoped=true&"
import script from "./admin-estates-list.vue?vue&type=script&lang=js&"
export * from "./admin-estates-list.vue?vue&type=script&lang=js&"
import style0 from "./admin-estates-list.vue?vue&type=style&index=0&id=0ac13142&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ac13142",
  null
  
)

export default component.exports